export const ApplicationPaths = {
  Login: `/Identity/Account/Login`,
  Register: `/Identity/Account/Register`,
  RegisterWithRedirect: `/Identity/Account/Register?returnUrl=/hq/customers/{id}?edit=true`,
  LogOut: `/Identity/Account/Logout`
};
